
































































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator';
import SingleText from '@/components/common/elements/SingleText.vue';
import SigninModel from '@/models/signinModel';
import { displayMessage, apiMessage, inputElement, passChangeSuccessRedirectName } from '@/constants/signin';

@Component({
  components: { SingleText }
})
export default class ResetPassword extends Vue {
  private signinModel = new SigninModel;
  private isLoading = false;
  private token = this.$route.params.token;
  
  private showIcon: {[k: string]: boolean} = {
    password: false,
    passwordConf: false
  };
  private password = '';
  private passwordConf = '';
  private errorMessage = '';

  private define = {};
  private inputElement = {};

  // 外部定義をプロパティーに追加
  mounted() {
    this.define = displayMessage.resetPass;
    this.inputElement = inputElement.resetPass;
  }

  /**
   * パスワード更新リクエストを送信
   * @returns void
   */
  private async requestChangePassword(): Promise<void> {
    try {
      this.setErrorMessage('');
      this.setLoading(true);
      
      await this.signinModel.setNewPassword(this.password, this.passwordConf , this.token);
      this.$router.push({ name: passChangeSuccessRedirectName });

    } catch($e) {
      this.setErrorMessage(apiMessage.fail);
    } finally {
      this.setLoading(false);
    }
  }

  /**
   * スピナーセット
   * @param {boolean} flg - 表示制御
   * @returns {void}
   */
  private setLoading(flg: boolean): void {
    this.isLoading = flg;
  }

  /**
   * エラーメッセージセット
   * @param {string} str - エラーメッセージ
   * @returns {void}
   */
  private setErrorMessage(str: string): void {
    this.errorMessage = str;
  }

}
